/**
 * Validates a mobile number:
 * - Digits only (no +, no country code prefix)
 * - Must be 10-11 digits
 * - Reject if starts with "91" and length > 10 (user typed country code)
 * - Reject if starts with "86" and length > 11 (user typed country code)
 */
function validatePhoneNumber(value) {
  if (!value) return { valid: false, error: "Mobile number is required" };

  const cleaned = value.replace(/\D/g, "");

  // Reject if user typed country code (91 or 86) as part of number
  if (cleaned.startsWith("91") && cleaned.length > 10) {
    return { valid: false, error: "Enter mobile number without country code" };
  }
  if (cleaned.startsWith("86") && cleaned.length > 11) {
    return { valid: false, error: "Enter mobile number without country code" };
  }

  // Must be 10-11 digits
  if (cleaned.length < 10 || cleaned.length > 11) {
    return { valid: false, error: "Enter a valid mobile number" };
  }

  return { valid: true, error: null };
}

function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
}

function validatePassword(password) {
    return password.length >= 6; // Example: password must be at least 6 characters long
}

function validateRegistrationForm(formData) {
    const { email, password, confirmPassword } = formData;
    const errors = {};

    if (!validateEmail(email)) {
        errors.email = "Invalid email address";
    }

    if (!validatePassword(password)) {
        errors.password = "Password must be at least 6 characters long";
    }

    if (password !== confirmPassword) {
        errors.confirmPassword = "Passwords do not match";
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors,
    };
}

export const productChecklist = (product) => {
  const media = product.media || [];

  const imageCount = media.filter(
    (m) =>
      m.type === "image" ||
      m.mimeType?.startsWith("image/")
  ).length;

  const videoCount = media.filter(
    (m) =>
      m.type === "video" ||
      m.mimeType?.startsWith("video/")
  ).length;

  return [
    {
      label: "Product title added",
      ok: !!product.title,
      requiredForSubmit: true,
    },
    {
      label: "Product description added",
      ok: !!product.description,
      requiredForSubmit: true,
    },
    {
      label: "At least 1 product image added",
      ok: imageCount >= 1,
      requiredForSubmit: true,
    },
    {
      label: "At least 1 product video added",
      ok: videoCount >= 1,
      requiredForSubmit: true,
    },
    {
      label: "Price set",
      ok: Number(product.price) > 0,
      requiredForSubmit: true,
    },
  ];
};


export { validateEmail, validatePassword, validateRegistrationForm, validatePhoneNumber };